// extracted by mini-css-extract-plugin
export default {"pointGray":"#a0a2a3","starsBox":"stars_box_starsBox__pDq1Z","onStar":"stars_box_onStar__OjvfE","offStar":"stars_box_offStar__U0bAP"};